import { render, staticRenderFns } from "./routerCard.vue?vue&type=template&id=e2497a34&scoped=true&"
import script from "./routerCard.vue?vue&type=script&lang=js&"
export * from "./routerCard.vue?vue&type=script&lang=js&"
import style0 from "./routerCard.vue?vue&type=style&index=0&id=e2497a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2497a34",
  null
  
)

export default component.exports